
import React from 'react';

interface QuizQuestionProps {
  question: {
    id: string;
    question: string;
    option_a: string;
    option_b: string;
    option_c: string;
    option_d: string;
  };
  selectedAnswer: string;
  onAnswerSelect: (questionId: string, answer: string) => void;
}

const QuizQuestion: React.FC<QuizQuestionProps> = ({ question, selectedAnswer, onAnswerSelect }) => {
  const options = [
    { id: 'option_a', label: 'A', value: question.option_a },
    { id: 'option_b', label: 'B', value: question.option_b },
    { id: 'option_c', label: 'C', value: question.option_c },
    { id: 'option_d', label: 'D', value: question.option_d },
  ];

  return (
    <div className="space-y-6">
      <h3 className="text-lg font-medium text-gray-900">{question.question}</h3>
      
      <div className="space-y-3">
        {options.map(option => (
          <div 
            key={option.id}
            className={`p-4 border rounded-lg cursor-pointer transition-colors ${
              selectedAnswer === option.id 
                ? 'border-[#0EA5E9] bg-[#0EA5E9]/10 text-[#0EA5E9]' 
                : 'border-gray-200 hover:border-[#0EA5E9]/50 hover:bg-[#F0F9FF]'
            }`}
            onClick={() => onAnswerSelect(question.id, option.id)}
          >
            <div className="flex items-start gap-3">
              <div className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full border ${
                selectedAnswer === option.id 
                  ? 'border-[#0EA5E9] bg-[#0EA5E9] text-white' 
                  : 'border-gray-300 text-transparent'
              }`}>
                {option.label}
              </div>
              <div>{option.value}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default QuizQuestion;
